import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import api from '../api/axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://127.0.0.1:8000/api';

export default function PromoSettings() {
  const { user } = useAuth();
  const [promo, setPromo] = useState({
    enabled: true,
    text: '🎉 PROMO SPESIAL! Sewa apartemen sekarang dapat diskon hingga 30% untuk 3 bulan pertama!',
    discount: '30%',
    badge: 'DISKON 30%',
    features: [
      'Kolam Renang 24 Jam',
      'Keamanan Terjamin',
      'Fasilitas Lengkap'
    ]
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetchPromoSettings();
  }, []);

  const fetchPromoSettings = async () => {
    try {
      const response = await api.get('/promo-settings');
      if (response.data) {
        setPromo(response.data);
      }
    } catch (error) {
      console.error('Error fetching promo settings:', error);
    }
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      const response = await api.post('/promo-settings', promo);
      if (response.data) {
        setMessage('Pengaturan promo berhasil disimpan!');
        setTimeout(() => setMessage(''), 3000);
      }
    } catch (error) {
      setMessage('Gagal menyimpan pengaturan promo');
    } finally {
      setLoading(false);
    }
  };

  if (!user) {
    return <div>Loading...</div>;
  }

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6">Pengaturan Promo Banner</h1>

      {message && (
        <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-4">
          {message}
        </div>
      )}

      <div className="bg-white rounded-lg shadow-md p-6" style={{ position: 'relative', zIndex: 1 }}>
        <div className="mb-6 p-4 bg-gray-50 rounded-lg" style={{ position: 'relative', zIndex: 10 }}>
          <label className="flex items-center cursor-pointer select-none" style={{ position: 'relative', zIndex: 10 }}>
            <input
              type="checkbox"
              checked={promo.enabled}
              onChange={(e) => {
                console.log('Checkbox clicked:', e.target.checked);
                setPromo({ ...promo, enabled: e.target.checked });
              }}
              className="mr-3 w-5 h-5 cursor-pointer accent-blue-600 rounded border-gray-300 focus:ring-2 focus:ring-blue-500"
              style={{ 
                minWidth: '20px', 
                minHeight: '20px', 
                position: 'relative', 
                zIndex: 100, 
                pointerEvents: 'auto' 
              }}
            />
            <span className="text-lg font-semibold">Aktifkan Promo Banner</span>
          </label>
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Teks Promo
          </label>
          <textarea
            value={promo.text}
            onChange={(e) => setPromo({ ...promo, text: e.target.value })}
            className="w-full p-3 border border-gray-300 rounded-md"
            rows="3"
            placeholder="Masukkan teks promo..."
          />
        </div>

        <div className="grid grid-cols-2 gap-4 mb-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Persentase Diskon
            </label>
            <input
              type="text"
              value={promo.discount}
              onChange={(e) => setPromo({ ...promo, discount: e.target.value })}
              className="w-full p-3 border border-gray-300 rounded-md"
              placeholder="30%"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Teks Badge
            </label>
            <input
              type="text"
              value={promo.badge}
              onChange={(e) => setPromo({ ...promo, badge: e.target.value })}
              className="w-full p-3 border border-gray-300 rounded-md"
              placeholder="DISKON 30%"
            />
          </div>
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Fitur Promo (3 item)
          </label>
          {promo.features && promo.features.map((feature, index) => (
            <div key={index} className="mb-2">
              <input
                type="text"
                value={feature}
                onChange={(e) => {
                  const newFeatures = [...promo.features];
                  newFeatures[index] = e.target.value;
                  setPromo({ ...promo, features: newFeatures });
                }}
                className="w-full p-3 border border-gray-300 rounded-md"
                placeholder={`Fitur ${index + 1}`}
              />
            </div>
          ))}
        </div>

        <div className="mb-6">
          <h3 className="text-lg font-semibold mb-3">Preview:</h3>
          {promo.enabled && (
            <div className="promo-banner" style={{ position: 'relative', margin: '0' }}>
              <div className="container">
                <div className="promo-content">
                  <div className="promo-text">{promo.text}</div>
                  <div className="promo-badge">{promo.badge}</div>
                </div>
              </div>
            </div>
          )}
        </div>

        <button
          onClick={handleSave}
          disabled={loading}
          className="bg-blue-600 text-white px-6 py-3 rounded-md hover:bg-blue-700 disabled:opacity-50"
        >
          {loading ? 'Menyimpan...' : 'Simpan Pengaturan'}
        </button>
      </div>
    </div>
  );
}